import React, { memo } from 'react';
import { Checkbox as ShadcnCheckbox } from '../ui/checkbox';
import { cn } from 'lib/utils';

interface Props {
  label: string;
  checked: boolean;
  variant?: 'checkbox' | 'radio';
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

function Checkbox(props: Props) {
  const {
    label,
    checked,
    variant = 'checkbox',
    onChange,
    disabled = false,
  } = props;

  return (
    <label
      className={cn(
        'flex items-center gap-2 cursor-pointer select-none',
        disabled && 'opacity-60 pointer-events-none'
      )}
    >
      <ShadcnCheckbox
        checked={checked}
        onCheckedChange={(val) => onChange(!!val)}
        disabled={disabled}
        className={cn(variant === 'radio' ? 'rounded-full' : 'rounded')}
      />
      <span className="text-base text-[#0a0a0a] font-normal">{label}</span>
    </label>
  );
}

export default memo(Checkbox);
